import React from 'react'
import DriverDashboard from '../DriverComponents/DriverDashboard/DriverDashboard'

const DriverDashBoardPage = () => {
  return (
    <>
    <DriverDashboard/>
    </>
  )
}

export default DriverDashBoardPage